module.exports = __webpack_public_path__ + "static/media/service-1.cc7bf39b.jpg";